<template>
  <section>
    <h3>{{ sidelight.topic }}</h3>
    <span v-html="sidelight.description"></span>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
    <van-tabs
      class="mt-3"
      type="card"
      color="#1989fa"
      v-model="active_tab"
      v-if="sidelight.videos.length > 0 || sidelight.photos.length > 0 || sidelight.photo_compressed_files.length > 0"
    >
      <van-tab name="videos" v-if="sidelight.videos.length > 0">
        <template #title>
          <span style="font-size: large;">{{ $t('sidelight.detail.heading.videos') }}</span>
        </template>
        <video-player class="mt-3" :videos="sidelight.videos"></video-player>
      </van-tab>
      <van-tab name="photos" v-if="sidelight.photos.length > 0">
        <template #title>
          <span style="font-size: large;">{{ $t('sidelight.detail.heading.photos') }}</span>
        </template>
        <h5 class="mt-3">{{ $t('sidelight.detail.instruction-text.click-thumbnail-to-enlarge-photo') }}</h5>
        <photo-viewer class="mt-3" :photos="sidelight.photos"></photo-viewer></van-tab>
      <van-tab name="photos-compressed-files" v-if="sidelight.photo_compressed_files.length > 0">
        <template #title>
          <span style="font-size: large;">{{ $t('sidelight.detail.heading.photos-compressed-file') }}</span>
        </template>
        <h5 class="mt-3">{{ $t('sidelight.detail.instruction-text.click-icon-to-download-file') }}</h5>
        <downloadable-file-list class="mt-3" :files="sidelight.photo_compressed_files"></downloadable-file-list>
      </van-tab>
    </van-tabs>
  </section>
</template>

<script>
import Vue from 'vue'

import { CardPlugin } from 'bootstrap-vue'
import { TabsPlugin } from 'bootstrap-vue'
import { Icon } from 'vant'
import { Tab, Tabs } from 'vant'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'
import DownloadableFileList from '@/components/lists/DownloadableFileList'
import VideoPlayer from '@/components/players/VideoPlayer'
import PhotoViewer from '@/components/viewers/PhotoViewer'
import i18n from '@/plugins/i18n.js'

Vue.use(CardPlugin)
Vue.use(Icon)
Vue.use(TabsPlugin)
Vue.use(Tab)
Vue.use(Tabs)

export default {
  i18n,
  name: 'sidelight-info',
  props: {
    sidelight: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      active_tab: 'videos'
    }
  },
  computed: {
    social_sharing_title() {
      return `${this.sidelight.topic}`
    },
    social_sharing_route() {
      return { name: 'sidelight', params: { id: this.sidelight.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.sidelight && this.sidelight.id) {
      gtag('event', `browse sidelight`, {
        code: this.sidelight.id,
        name: this.sidelight.topic,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar,
    DownloadableFileList,
    PhotoViewer,
    VideoPlayer
  }
}
</script>